export const  LOCAL_STORAGE_TOKEN_ADMIN_CMS = 'admin_cms_token'
export const LOCAL_STORAGE_USER_ADMIN_CMS = 'user_cms'
export const LOCAL_STORAGE_USER_PHONE_NUMBER = 'phone_number'
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'admin_cms_refresh_token'
export const LOCAL_STORAGE_TOKEN_KEY = 'token_portal'
export const USER_INFO = 'user_info'
export const TITLE_NAV = 'TITLE_NAV'
